import React from "react";
import styles from "../styles/Footer.module.css";
export const Footer = () => {
  return (
    <div>
      <div className={styles.footer}>
        <div className={styles.footerA1}>
          <h4>Tata Trust</h4>
          <h4>QuiQ PiQ</h4>
          <h4>Authentic Brands</h4>
          <h4>Easy Returns</h4>
        </div>
        <div className={styles.footerA2}>
          <div className={styles.fA21}>
            <h4>Tata MarketPlace</h4>
            <p>About Us</p>
            <p>Careers</p>
            <p>Sell With Us</p>
            <p>Terms of Use</p>
            <p>Privacy Policy</p>
            <p>Affiliates</p>
            <p>Sitemap</p>
          </div>
          <div className={styles.fA21}>
            <h4>Customer Service</h4>
            <p>Shopping</p>
            <p>Offers & Promotions</p>
            <p>Payments</p>
            <p>Cancellation</p>
            <p>Returns & Refunds</p>
            <p>CliQ and PiQ</p>
            <p>Return To Store</p>
            <p>Electronics Returns Policy</p>
            <p>Contact Us</p>
            <p>Reviews Guidelines</p>
            <p>Furniture Return Policy</p>
            <p>Assembly Policy</p>
          </div>
          <div className={styles.fA21}>
            <h4>My Tata CLiQ</h4>
            <p>My Account</p>
            <p>My Orders</p>
            <p>My Shopping Bag</p>
            <p>My Wishlist</p>
          </div>
          <div className={styles.fA21} style={{ width: "40%" }}>
            <div>
              <h4>Tata CLiQ Offerings</h4>
            </div>
            <div className={styles.fA24}>
              <p>Watches for Men | </p>
              <p>Campus Shoes | </p>
              <p>Sandals For men | </p>
              <p>Sneakers For men | </p>
              <p>Reebk Shoes | </p>
              <p>Cotton Kurtis | </p>
              <p>Woodland Shoes | </p>
              <p>Jumpsuits | </p>
              <p>Allen Solly | </p>
              <p>Sparx Shoes | </p>
              <p>Gold Rings | </p>
              <p>Formal SJoes for Men | </p>
              <p>Sports Shoes for Men | </p>
              <p>Wallets for Men | </p>
              <p>Ladies Watches | </p>
              <p>Trolley Bags | </p>
              <p>Handsbags for Women | </p>
              <p>Sling Bags for Women | </p>
              <p>Casual Shoes for Men | </p>
              <p>Boots for Men | </p>
              <p>Digital Watches | </p>
              <p>Sonata Watches | </p>
              <p>Sneakers for Women | </p>
              <p>Boots for Women | </p>
              <p>Digital Watches | </p>
              <p>Sketchers | </p>
              <p>Malabargold | </p>
              <p>Utsa | </p>
              <p>Vark | </p>
              <p>Gia | </p>
              <p>LoV | </p>
              <p>Sitemap </p>
            </div>
          </div>
        </div>
        <div className={styles.footerA3}>
          <div className={styles.fA31}>
            <div className={styles.fA311}>
              <h4>Download App</h4>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13994142335006.png"
                  alt=""
                />
              </div>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13994142892062.png"
                  alt=""
                />
              </div>
            </div>
            <div className={styles.fA311}>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13976586715166.png"
                  alt=""
                />
              </div>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13976586780702.png"
                  alt=""
                />
              </div>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13976586846238.png"
                  alt=""
                />
              </div>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13976586911774.png"
                  alt=""
                />
              </div>
              <div className={styles.fA311I}>
                <img
                  src="https://assets.tatacliq.com/medias/sys_master/images/13976586977310.png"
                  alt=""
                />
              </div>
            </div>
            <div className={styles.fA311}>
              <p>© 2023 Tata CLiQ | All rights reserved</p>
            </div>
          </div>
        </div>
        <div className={styles.footerA4}>
          <div className={styles.footerA41}>
            <h3>
              TATA CLiQ: Shop Online with India's most trusted destination
            </h3>
            <p>
              Genuine products from all the top brands get delivered right to
              your doorstep. Our sleek, immersive design allows you to easily
              navigate between categories and brand stores so that you can find
              a wide selection of womenswear, menswear, kidswear, footwear,
              watches, accessories, footwear, watches and accessories online.
              You can also check our great offers and get the best prices on
              various products across lifestyle, fashion, and more.
            </p>
          </div>
          <div className={styles.footerA41}>
            <h3>
              Online Shopping: Fast & convenient with the click of a button
            </h3>
            <p>
              The upside of online shopping at TATA CLiQ online store, is that
              you'll save on time and most importantly money with TataCliq
              offers. It's as simple as comparing products and prices online
              before making the right buy. What's more, you also have the option
              to pay for your favourite brands and products using our easy EMI
              options. Of course, you can buy and try - in the convenience of
              your home. Returns are easy too: We'll pick up your returns for
              free or you can also drop off the goods at the nearest brand
              store.
            </p>
          </div>
          <div className={styles.footerA41}>
            <h3>Tata CLiQ Shopping App: just a few clicks on Android & iOS</h3>
            <p>
              Download the Android app from the Play Store or the iOS app from
              Apple App Store and get set to enjoy a range of benefits. Apart
              from the best deals, amazing offers and the latest styles online,
              the app also gives you the flexibility to shop at your
              convenience. Use the easy share options to share your shopping
              with your friends and family to ensure you're buying something
              perfect. With constant updates and a host of new features being
              introduced constantly, enjoy a shopping experience that you'll
              love.
            </p>
          </div>
          <div className={styles.footerA41}>
            <h3>TATA CLiQ: The most genuine place for Fashion and Lifestyle</h3>
            <p>
              With an exclusive Brand Store for Westside Online we have most of
              your trendy shopping needs taken care of. Make TATA CLiQ your
              online shopping destination and get the best deals on your
              favourite brands, with 100% genuine products. Be it jewellery or
              makeup, you can count on TATA CLiQ for receiving only the most
              authentic products.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
